import React, { FC, useState } from "react";
import "./stepper.panel.css";
import { TiTick } from "react-icons/ti";

export function useStepper(list: string[]) {
    const steps = list;
    const [currentStep, setCurrentStep] = useState(1);
    const [complete, setComplete] = useState(false);

    return {steps, currentStep, setCurrentStep, complete, setComplete};
}

type StepperPanelProps = {
    children?: React.ReactNode,
    steps: string[],
    currentStep: number,
    complete: boolean
};

const StepperPanel: FC<StepperPanelProps> = ({steps, currentStep, complete, children}) => {  
  return (<React.Fragment>
      <div className="flex justify-between px-16 m-2">
        {steps?.map((step, i) => (
          <div
            key={i}
            className={`step-item ${currentStep === i + 1 && "active"} ${
              (i + 1 < currentStep || complete) && "complete"
            } `}>
            <div className="step">
              {i + 1 < currentStep || complete ? <TiTick size={24} /> : i + 1}
            </div>
            <p className="text-sky-700 dark:text-teal-200">{step}</p>
          </div>
        ))}
      </div>
      {children}
    </React.Fragment>
  );
};

export default StepperPanel;